import { render } from "./CustomerSearch.vue?vue&type=template&id=21bc61ff&scoped=true"
import script from "./CustomerSearch.vue?vue&type=script&lang=js"
export * from "./CustomerSearch.vue?vue&type=script&lang=js"

import "./CustomerSearch.vue?vue&type=style&index=0&id=21bc61ff&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21bc61ff"]])

export default __exports__